<template>
  <surg-approve
    v-if="surgery && documents"
    :surgery="surgery"
    :files="documents"
    :isInfo="true"
    @approveGoBack="$router.go(-1)"
  />
</template>

<script>
import {
  emptySurgeryDocs,
  getSurgeryDocuments
} from "../../../utilities/download-document";
import SurgApprove from "./SurgerySummary/SurgApprove.vue";

export default {
  components: { SurgApprove },
  name: "SurgInfo",
  data() {
    return {
      surgery: null,
      documents: emptySurgeryDocs
    };
  },
  methods: {
    async getDocuments() {
      this.documents = await getSurgeryDocuments(this.$route.params.id);
    }
  },
  async mounted() {
    this.$root.$on("getSurgeryInfo", () => {
      this.getDocuments();
    });

    const res = await this.$API.getSurgeryInfo(this.$route.params.id);
    const resOrders = await this.$API.getSurgeryOrders(this.$route.params.id);

    if (res && res.status == "OK") {
      this.surgery = res.message.surgery;

      // patient
      this.surgery.first_name = res.message.patient.firstName;
      this.surgery.last_name = res.message.patient.lastName;
      this.surgery.passport = res.message.patient.passport;
      this.surgery.birth_date = res.message.patient.birthDate;
      if (
        res.message.patient.gender === "male" ||
        res.message.patient.gender === "זכר"
      ) {
        this.surgery.gender = "male";
      } else if (
        res.message.patient.gender === "female" ||
        res.message.patient.gender === "נקבה"
      ) {
        this.surgery.gender = "female";
      } else {
        this.surgery.gender = "";
      }
      this.surgery.phone = res.message.patient.phone;
      this.surgery.second_phone = res.message.patient.phone2;
      this.surgery.apotropos = res.message.patient.apotropos;
      this.surgery.user_language = res.message.patient.language;
      this.surgery.start_date = res.message.surgery.start_date;
      this.surgery.insurance_fee = res.message.surgery.insurance_fee;
      this.surgery.handle_insurance_claim_by_hmc =
        res.message.surgery.handle_insurance_claim_by_hmc;
      if (res.message.patient.passport_type) {
        this.surgery.passport_type = res.message.patient.passport_type;
      }
      // insurance
      this.surgery.insurance_status_heb =
        res.message.surgery.insurance_status_heb;
      this.surgery.insurance_code = res.message.surgery.insurance_code;
      // pre_surgery_appointments
      this.surgery.pre_surgery_appointments =
        res.message.pre_surgery_appointments;
      // 1 - current_surgery && 8 - insurance_surgery
      this.surgery.current_surgery = [];
      this.surgery.insurance_surgery = [];
      if (resOrders && resOrders.status == "OK" && resOrders.data?.orders) {
        const current_surgery = resOrders.data?.orders;
        current_surgery.map(s => {
          if (s.tafnit_code === "9000") return;

          const duration = s.duration
            ? this.$moment.utc(s.duration * 1000).format("HH:mm")
            : "HH:mm";
          this.surgery.current_surgery.push({
            // surgery_category: s.surgery_category ?? "",
            is_primary: s.is_primary || "",
            procedure: s.icd9_procedure,
            surgery_name: s.type,
            surgery_duration: duration,
            default_surgery_duration: duration,
            side: s.side ?? ""
          });

          let insurance = s.insurance_name;
          if (
            s.tafnit_code == 1 &&
            insurance !== "כללית מושלם" &&
            insurance !== "פרטי"
          ) {
            insurance = "חברת ביטוח";
          }
          this.surgery.insurance_surgery.push({
            insurance,
            // surgery_category: insurance.surgery_category,
            surgery_name: s.insurance_procedure,
            notice: s.notes
          });
        });
      }
      // 2 - indication
      this.surgery.indication = this.surgery.indication;
      //
      this.surgery.current_diagnosis = [];
      this.surgery.past_diagnosis = [];
      if (this.surgery.diagnosis) {
        const diagnosis = JSON.parse(this.surgery.diagnosis);
        // 3 - current_diagnosis
        if (diagnosis.current && diagnosis.current.length) {
          diagnosis.current.map(diagnosis => {
            this.surgery.current_diagnosis.push({
              side: diagnosis.side ?? "",
              diagnosis_number: diagnosis.diagnosis_number,
              diagnosis_name: diagnosis.diagnosis_name,
              notice: diagnosis.notice
            });
          });
        }
        // 4 - past_diagnosis
        if (diagnosis.past && diagnosis.past.length) {
          diagnosis.past.map(diagnosis => {
            this.surgery.past_diagnosis.push({
              side: diagnosis.side ?? "",
              diagnosis_number: diagnosis.diagnosis_number,
              diagnosis_name: diagnosis.diagnosis_name,
              notice: diagnosis.notice
            });
          });
        }
        // checkbox past_diagnosis
        // this.surgery.checkbox_past_diagnosis;
      }
      // 5 - physical_examination
      this.surgery.physical_examination = this.surgery.physicalExam;
      //
      this.surgery.medication_sensitivity = [];
      this.surgery.material_sensitivity = [];
      const sensitivity = JSON.parse(res.message.patient.sensitivity);
      if (sensitivity) {
        // 6 - medication_sensitivity
        if (sensitivity.medication && sensitivity.medication.length) {
          sensitivity.medication.map(sens => {
            this.surgery.medication_sensitivity.push({
              response: sens.response,
              severity: sens.severity,
              medication: sens.medication,
              notice: sens.notice
            });
          });
        }
        // 7 - material_sensitivity
        if (sensitivity.material && sensitivity.material.length) {
          sensitivity.material.map(material => {
            this.surgery.material_sensitivity.push({
              response: material.response,
              severity: material.severity,
              material_name: material.material_name,
              notice: material.notice
            });
          });
        }
      }

      if (
        this.surgery.current_surgery.length === 1 &&
        this.surgery.current_surgery[0].surgery_name === "1 > RHINOPLASTY" &&
        this.surgery.secondary_insurance_name === "כללית מושלם"
      ) {
        this.surgery.insurance_name = "כללית מושלם";
      }
    }

    await this.getDocuments();
  }
};
</script>
